import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { getReceiver, updateReceiver, createReceiver, createReceiverByAdmin } from "@api/correspondence/object";
import Editor from '@/components/editor';
import { getList } from "@api/setting/dictionary";
export default {
  name: "details-page",
  components: {
    Editor: Editor
  },
  computed: {
    isArtificial: function isArtificial() {
      return this.form.c03CheckType === '人工';
    }
  },
  props: {
    id: {
      default: function _default() {
        return undefined;
      }
    },
    readOnly: {
      default: function _default() {
        return false;
      }
    },
    type: {
      default: function _default() {
        return undefined;
      }
    },
    name: {
      type: String,
      default: function _default() {
        return undefined;
      }
    },
    taskId: {
      type: String,
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    var _this = this;
    var isArtificial = function isArtificial(rule, value, callback) {
      if (!value && _this.isArtificial) {
        callback(new Error('请输入工商登记注册地址'));
        return;
      }
      callback();
    };
    var validateCheckProcess = function validateCheckProcess(rule, value, callback) {
      if (!_this.form.c03CheckType) {
        return callback(new Error('请先选择核验方式'));
      } else if (_this.form.c03CheckType === '人工' && !value) {
        return callback(new Error('请输入核验过程'));
      }
      return callback();
    };
    return {
      form: {
        c03CheckDate: undefined,
        c03CheckProcess: undefined,
        c03CheckStaff: undefined,
        c03CheckType: undefined,
        c03CorrectAddress: undefined,
        c03CusName: this.name,
        c03CusType: undefined,
        checkable: false,
        modifiable: true,
        removable: false,
        updatable: false
      },
      editText: undefined,
      rules: {
        c03CusName: [{
          required: true,
          message: '请输入函证对象名称',
          trigger: 'change'
        }],
        c03CusType: [{
          required: true,
          message: '请选择函证对象类型',
          trigger: 'change'
        }],
        c03CorrectAddress: [{
          required: true,
          validator: isArtificial,
          message: '请输入工商登记注册地址',
          trigger: 'change'
        }],
        c03CheckType: [{
          required: true,
          message: '请选择核验方式',
          trigger: 'change'
        }],
        c03CheckProcess: [{
          message: '请输入核验过程',
          trigger: 'change',
          validator: validateCheckProcess
        }]
      },
      loading: false,
      tag: undefined,
      permissions: '',
      options: [],
      typeOptions: ['银行', '企业', '个人']
    };
  },
  methods: {
    processChange: function processChange(val) {
      this.form.c03CheckProcess = val;
    },
    canBeHandle: function canBeHandle(type) {
      if (this.id) {
        return this.permissions.includes(type);
      }
      return true;
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, res, _yield$_this2$$awaitT3, _yield$_this2$$awaitT4, _err, _res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this2.$checkForm();
            case 1:
              if (!_this2.id) {
                _context.n = 4;
                break;
              }
              _this2.loading = true;
              params = _this2.form;
              _context.n = 2;
              return _this2.$awaitTo(updateReceiver(_this2.id, _objectSpread({}, params), {
                'If-Match': _this2.tag
              }));
            case 2:
              _yield$_this2$$awaitT = _context.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              res = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 6;
              break;
            case 4:
              _this2.loading = true;
              _context.n = 5;
              return _this2.$awaitTo(_this2.taskId ? createReceiver(_this2.form, _this2.taskId) : createReceiverByAdmin(_this2.form));
            case 5:
              _yield$_this2$$awaitT3 = _context.v;
              _yield$_this2$$awaitT4 = _slicedToArray(_yield$_this2$$awaitT3, 2);
              _err = _yield$_this2$$awaitT4[0];
              _res = _yield$_this2$$awaitT4[1];
              _this2.loading = false;
              if (!_err) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              if (!_this2.taskId) {
                _this2.$message.success('操作成功');
              }
              _this2.$emit('submit', _this2.form.c03CusName);
            case 7:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getDetail: function getDetail() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, res, headers, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.loading = true;
              _context2.n = 1;
              return _this3.$awaitTo(getReceiver(_this3.id));
            case 1:
              _yield$_this3$$awaitT = _context2.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              res = _yield$_this3$$awaitT2[1];
              _this3.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              headers = res.headers, data = res.data;
              _this3.form = data;
              _this3.editText = data.c03CheckProcess;
              _this3.tag = headers.etag;
              console.log(res);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getOptions: function getOptions(type, key) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: type
              }));
            case 1:
              _yield$_this4$$awaitT = _context3.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1].data;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              if (Array.isArray(data.datas)) {
                _this4[key] = data.datas.filter(function (sub) {
                  return sub.n04Enabled;
                });
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    if (this.id) {
      this.getDetail();
    }
    // this.getOptions('c02Type','typeOptions');
    this.getOptions('c03CheckType', 'options');
  }
};